<template>
  <v-app id="main" :style="{background: $vuetify.theme.themes.light.background}">
    <Navbar
      :studioName="studioName"
      :studioLogo="studioLogo"
      :isStudioAdmin="power == 'admin'"
      :isVibefamAdmin="power === 'vibefamAdmin'"
      v-if="loggedIn && doneLoading"
    />
    <v-content>
      <v-container fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <!-- <v-content>
      <Navbar
        :studioName="studioName"
        :studioLogo="studioLogo"
        :isAdmin="power == 'admin'"
        v-if="loggedIn && doneLoading"
      />
      <router-view class="ma-0 pa-0"></router-view>
    </v-content>-->
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  name: "App",

  components: {
    Navbar,
  },
  created() {
  },
  data: () => ({
    power: "",
    loggedIn: false,
    doneLoading: false,
    studioId: "",
    studioName: "",
    studioLogo: "",
  }),
  methods: {},
};
</script>
